import React from 'react';
import ProfileCard from '../ProfileCard/ProfileCard';
import {
  DeleteOutlined,
  LibraryAddOutlined,
  ModeOutlined,
  WorkOutlineOutlined
} from '@mui/icons-material';
import colors from '../../../../scss/colors';
import NudgeIcon from '../../../../Components/common/CustomIcon/CustomIcon';

function ResumeSection({
  shouldShowNudge,
  nudgetText,
  sectionTitle,
  data = [],
  pillsType = false,
  icon: Icon = WorkOutlineOutlined,
  onAdd,
  onEdit,
  onDelete,
  renderItem,
  hideInlineIcon = false,
  placeholder
}) {
  return (
    <ProfileCard customClass='gap-4'>
      <div className='flex flex-row justify-between items-start w-full'>
        <div className='flex'>
          <h4 className='!text-base sm:!text-xl !font-medium'>{sectionTitle}</h4>
        </div>
        <div className='flex gap-3'>
          {pillsType ? (
            data.length ? <ModeOutlined
              className="!text-xl md:!text-2xl"
              sx={{ color: colors.NAVY_BLUE, cursor: 'pointer' }}
              onClick={() => onEdit(data)}
            /> : 
              <NudgeIcon
                iconComponent={<LibraryAddOutlined />}
                onClick={() => onEdit(data)}
                nudge={shouldShowNudge}
                tooltipText="Please complete the section"
                iconColor={colors.NAVY_BLUE}
              />
          ) : (
            <NudgeIcon
              iconComponent={<LibraryAddOutlined />}
              onClick={onAdd}
              nudge={shouldShowNudge}
              tooltipText="Please complete the section"
              iconColor={colors.NAVY_BLUE}
            />
          ) }
        </div>
      </div>

      {pillsType ? (
        <div className='flex flex-row flex-wrap gap-2 w-full'>
          {data?.length ? data?.map((item, index) => (
            <div
              key={index}
              className='px-4 py-2 rounded-full text-gray-600 text-sm bg-gray-200'
            >
              {renderItem?.(item)}
            </div>
          )) : <p className='text-gray-400'>{placeholder}</p>}
        </div>
      ) : (
        data?.length ? data?.map((item, index) => (
          <div key={index} className='flex flex-row items-start w-full gap-3'>
            <div className='flex flex-col'>
              <div className='border rounded-full border-secondary p-2 mb-2'>
                <Icon />
              </div>
            </div>

            <div className='flex flex-col flex-grow text-sm md:text-base'>{renderItem?.(item)}</div>

            <div className={`${hideInlineIcon ? 'hidden' : 'flex'} md:flex flex-row gap-2 ml-auto`}>
              <ModeOutlined
                className="!text-xl md:!text-2xl"
                sx={{ color: colors.NAVY_BLUE, cursor: 'pointer' }}
                onClick={() => onEdit?.(item)}
              />
              <DeleteOutlined
                className="!text-xl md:!text-2xl"
                sx={{ color: colors.NAVY_BLUE, cursor: 'pointer' }}
                onClick={() => onDelete?.(item)}
              />
            </div>
          </div>
        )) : <p className='text-gray-400'>{placeholder}</p>
      )}
    </ProfileCard>
  );
}

export default ResumeSection;
